import type { ValueFormatterParams } from "ag-grid-community"

import type { PricingGridRow } from "./types"

import { UOM_RENDER_PRECISION } from "@/constants/formats"
import { formatNumber } from "@/utils/number"

const numberFormatter =
  ({ prefix = "", suffix = "" }: { prefix?: string; suffix?: string }) =>
  ({ value }: ValueFormatterParams<PricingGridRow>): string =>
    value === null ? "" : `${prefix}${formatNumber(value as number, UOM_RENDER_PRECISION)}${suffix}`

const uomSuffixFormatter = (uomName: string) =>
  numberFormatter({
    suffix: ` ${uomName}`,
  })

export const FORMATTERS = {
  financial: numberFormatter({ prefix: "$" }),
  uomSuffix: uomSuffixFormatter,
  percentSuffix: numberFormatter({ suffix: "%" }),
} as const
